export const getStatusColor = (status) => {
    const colors = {
        pending: 'yellow',
        approved: 'green',
        rejected: 'red',
        confirmed: 'blue',
        completed: 'green',
        cancelled: 'red',
        assigned: 'blue',
        in_progress: 'orange',
        'Pending': 'yellow',
        'Approved': 'green',
        'Rejected': 'red',
        'Processing': 'orange',
        'Shipped': 'blue',
        'Delivered': 'green',
        'Cancelled': 'red'
    };
    return colors[status] || 'gray';
};

export const getPriorityColor = (priority) => {
    const colors = {
        low: 'green',
        medium: 'yellow',
        normal: 'blue',
        high: 'orange',
        urgent: 'red'
    };
    return colors[priority] || 'gray';
};

export const formatDate = (dateString, options = {}, locale = 'en-IN') => {
    if (!dateString) return 'N/A';
    try {
        const defaultOptions = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            ...options
        };
        return new Date(dateString).toLocaleDateString(locale, defaultOptions);
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid Date';
    }
};

export const formatTime = (dateString, options = {}, locale = 'en-IN') => {
    if (!dateString) return 'N/A';
    try {
        const defaultOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            ...options
        };
        const date = new Date(dateString);
        return date.toLocaleTimeString(locale, defaultOptions).toUpperCase();
    } catch (error) {
        console.error('Error formatting time:', error);
        return 'Invalid Time';
    }
};

export const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '₹0';
    try {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    } catch (error) {
        console.error('Error formatting currency:', error);
        return `₹${amount}`;
    }
};

export const formatRelativeTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;

    return date.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
